export const gamImageAccept = {
  // Define allowed file types using MIME types and their corresponding extensions
  // This format is required by modern browsers for proper file type validation
  // Each MIME type maps to an array of allowed file extensions
  'image/jpeg': ['.jpeg', '.jpg'],
  'image/png': ['.png'],
  'image/gif': ['.gif']
}
export const gamImageFormats = ['jpeg', 'gif', 'png', 'jpg']

export const gamVideoFormats = [
  'avi',
  'mov',
  'mp4',
  'mpeg',
  'mpeg4',
  'mpegps',
  'ogg',
  'mp2t',
  'flv',
  '3gpp',
  'webm',
  'wmv'
]
